import { Link, Text } from "@fluidattacks/design";
import first from "lodash/first";

const baseUrl =
  "https://help.fluidattacks.com/portal/en/kb/articles/criteria-vulnerabilities";
const criteriaVulnerabilitiesUrl =
  "https://help.fluidattacks.com/portal/en/kb/criteria/vulnerabilities";

const policyFormatter = (name: string): JSX.Element => {
  const url = name.startsWith("All")
    ? criteriaVulnerabilitiesUrl
    : `${baseUrl}-${first(name.split(".")) ?? ""}`;

  return (
    <div style={{ width: "95%" }}>
      <Link href={url} iconPosition={"hidden"}>
        <Text
          color={"#212a36"}
          overflow={"hidden"}
          size={"md"}
          textOverflow={"ellipsis"}
          whiteSpace={"nowrap"}
        >
          {name}
        </Text>
      </Link>
    </div>
  );
};

export { policyFormatter, criteriaVulnerabilitiesUrl, baseUrl };
